import React, { useEffect, useRef, useState } from 'react';
import { Link, useRouteMatch, useLocation, useParams } from "react-router-dom";

import { isJRootServer } from '../core/DomainUtils';

export const RawData = () => {

    const [data, setData] = useState({ fileInfos: [] });

    const location = useLocation();
    let { id } = useParams();
    const pathname = location.pathname;

    const id1 = id ? pathname.substr(pathname.indexOf("raw/") + 4, pathname.length - 1) : id;

    const pathParts = id1?id1.split('/'):"";

//    console.log("id", id)
//    console.log("id1", id1)
//    console.log("pathname", pathname)
//    console.log("pathParts", pathParts)

    let rootServerType="a";
    if (isJRootServer()) {
        rootServerType="j";
    }

    useEffect(() => {

        fetch("/rssac-metrics/ui/"+rootServerType+"/raw/" + (id1 ? id1 : "raw")+".json")
            .then((response) => response.json())
            .then((data) => {
                setData(data)
            });
    }, [id1]);

    return<div class="container">
              <div class="min-vh-100 mb-4">

                <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li className='breadcrumb-item'>
                            <Link to={"/"}><span>HOME</span></Link>
                            </li>
                             {pathParts &&  pathParts.map((path, index) => {
                                                const isLastItem = index === pathParts.length - 1;
                                                const breadcrumbLink=index>0?pathParts[index-1]+"/"+path:path
                                return <li key={"path" + index}
                                            className={isLastItem?'breadcrumb-item active' : 'breadcrumb-item'}>

                                    {!isLastItem && <Link  to={"/raw/"+breadcrumbLink}>{path}</Link>}
                                    {isLastItem && <span>{path}</span>}
                                    </li> })}
                        </ol>
                    </nav>
                  <div class="card">
        <table className="table table-striped table-bordered table-hover mb-0  ">
            <thead>
                <tr>
                    <th scope="col">Name</th>
                    {data.show_size && <th scope="col">Size (Bytes)</th>}

                </tr>
            </thead>
            <tbody>

                {data && data.fileInfos && data.fileInfos.map((fileInfo, index) => {
                    return <tr key={"file_info" + index}>
                        <td>

                            {fileInfo.directory && <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                                                     class="bi bi-folder" viewBox="0 0 16 16">
                                                                    <path d="M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31zM2.19 4a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4H2.19zm4.69-1.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707z"/>
                                                                </svg>&nbsp;</span>}
                            {!fileInfo.directory && <span>
<svg xmlns="http://www.w3.org/2000/svg" width="16"
                                     height="16" fill="currentColor"
                                     class="bi bi-file-text" viewBox="0 0 16 16">
  <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/>
  <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>
</svg>&nbsp;
                            </span>}
                            {!fileInfo.directory &&<a target="_blank" href={"/rssac-metrics/raw/" + (fileInfo.parent != null ? fileInfo.parent + '/' : '') + fileInfo.name} >{fileInfo.name}
                            </a>}
                            {fileInfo.directory &&<Link to={"/raw/" + (fileInfo.parent != null ? fileInfo.parent + '/' : '') + fileInfo.name} >{fileInfo.name}
                            </Link>}

                        </td>
                        {data.show_size && <td>{fileInfo.size}</td>}

                    </tr>

                })}

            </tbody>
        </table>
    </div>
    </div>
    </div>
}